module.exports = __webpack_public_path__ + "static/media/accountItemBg.b98a72eb.png";